import { NgxSpinnerModule } from 'ngx-spinner';
import { LoginLayoutModule } from '../../@theme/pages/login-layout/login-layout.module';
import { LoginRoutingModule } from './login-layout/login-routing.module';
import { MenuComponent } from './menu/menu.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NbMenuModule } from '@nebular/theme';

import { ThemeModule } from '../../@theme/theme.module';
import { WelcomeModule } from './welcome/welcome.module';
import { PagesRoutingModule } from './pages-routing.module';
import { MenuDauTuComponent } from './menu-dau-tu/menu-dau-tu.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { DataAccessHistoryComponent } from './data-access-history/data-access-history.component';
import { ViewImageComponent } from './view-image/view-image.component';

@NgModule({
  imports: [
    PagesRoutingModule,
    ThemeModule,
    NbMenuModule,
    WelcomeModule,
    NgxSpinnerModule
  ],
  declarations: [
    MenuComponent,
    MenuDauTuComponent,
    UserInfoComponent,
    ChangePasswordComponent,
    DataAccessHistoryComponent,
    ViewImageComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class PagesModule {
}
